// src/App.jsx
import { Suspense, useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './globalStyles';
import { lightTheme, darkTheme } from './theme';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollToTop from './components/ScrollToTop'; // ⬅️ добавлено

// страницы
import HomePage from './pages/HomePage'; // ⬅️ актуальное имя файла
import MetalPage from './pages/MetalPage';
import MebliPage from './pages/MebliPage';
import HplPage from './pages/HplPage';
import DeliveryPage from './pages/DeliveryPage';
import ContactsPage from './pages/ContactsPage';
import NotFound from './pages/NotFound';

// Инфо
import DocsPage from './pages/DocsPage';
import Vacancies from './pages/Vacancies';
import FAQ from './pages/FAQ';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import VideosPage from './pages/VideosPage';

// Новая страница систем
import SystemsPage from './pages/SystemsPage';

const Wrap = styled.div`min-height:100dvh; display:flex; flex-direction:column;`;
const Main = styled.main`flex:1;`;

export default function App() {
  const [themeMode, setThemeMode] = useState(() =>
    typeof window !== 'undefined' ? localStorage.getItem('themeMode') || 'system' : 'system'
  );
  const [isDark, setDark] = useState(false);

  // Авто-тема по времени / системным настройкам
  useEffect(() => {
    const apply = () => {
      const hour = new Date().getHours();
      const prefersDark = typeof window !== 'undefined'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : false;

      if (themeMode === 'dark') return setDark(true);
      if (themeMode === 'light') return setDark(false);

      setDark(prefersDark || hour >= 20 || hour < 7);
    };

    apply();
    const timer = setInterval(apply, 60_000);
    let media;
    if (typeof window !== 'undefined') {
      media = window.matchMedia('(prefers-color-scheme: dark)');
      media.addEventListener('change', apply);
    }
    return () => {
      clearInterval(timer);
      media?.removeEventListener('change', apply);
    };
  }, [themeMode]);

  const cycleTheme = () => {
    setThemeMode((prev) => {
      const next = prev === 'light' ? 'dark' : prev === 'dark' ? 'system' : 'light';
      if (typeof window !== 'undefined') localStorage.setItem('themeMode', next);
      return next;
    });
  };

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <GlobalStyle />
      <Wrap>
        <Header isDark={isDark} onCycleTheme={cycleTheme} />
        <Main>
          {/* Скролл вверх на смену маршрута / обработка #hash */}
          <ScrollToTop />
          <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/metal" element={<MetalPage />} />
              <Route path="/mebli" element={<MebliPage />} />
              <Route path="/hpl" element={<HplPage />} />
              <Route path="/delivery" element={<DeliveryPage />} />

              {/* Інфо */}
              <Route path="/info" element={<DocsPage />} />
              <Route path="/info/docs" element={<DocsPage />} />
              <Route path="/info/vacancies" element={<Vacancies />} />
              <Route path="/info/faq" element={<FAQ />} />
              <Route path="/info/videos" element={<VideosPage />} />

              {/* Статьи */}
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/articles/:id" element={<ArticleDetailPage />} />

              {/* Інженерні системи */}
              <Route path="/systems" element={<SystemsPage />} />

              <Route path="/contacts" element={<ContactsPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Main>
        <ScrollToTopButton />
        <Footer />
      </Wrap>
    </ThemeProvider>
  );
}
